<template>
	<div class="newcenter">
		
			<div class="img">
				<img :src="banner"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="path">
					<el-breadcrumb separator-class="el-icon-arrow-right">
					  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  	<el-breadcrumb-item>新闻中心</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				
				<!--内容-->
				<div class="content">
					<div class="title">
						<ul>
							<li @click="selItem(item.item_id)" 
							:class="itemId==item.item_id?'active':''"
							v-for="(item,index) in navlist"
							:id="'news_'+item.item_id"
							:key="index" >
							{{item.item_name}}
							</li>
						</ul>
					</div>
					<router-view/>
				</div>
				<newsList ref="id"></newsList>
			</div>
			
	
		
	</div>
</template>

<script>
	import newsList from './Ncom/NewsList';
	export default {
		name:'NewCenter',
		components:{newsList},
		data(){
			return{
				msg:'newcenter',
				navlist: [],
				itemId:'',
				sel:'',
				banner:''
			}
		},
		methods:{
			selItem(item) {
				$('.active').removeClass('active');
				$('#news_'+item).addClass('active');
				this.itemId = item;
				this.$refs.id.getNewsList(item);
			},
			getData(){
				let id = this.$route.query.tid;
				if(id == 9){
					this.itemId = 1;
				}else if(id == 10){
					this.itemId = 2;
				}
			},
			getNewsNav(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.newsNavApi,
					data: {}
				})
				.then((res) => {
					this.navlist = res.data.data;
					if(this.navlist[0] && !this.itemId){
						this.selItem(this.navlist[0].item_id);
						this.itemId = this.navlist[0].item_id;
					}else{
						this.selItem(this.itemId);
					}
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'3',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner3;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		watch: {
			'$route': function(to, from) {
		      	if (to.path == from.path) {
		       		this.getData();
		       		this.selItem(this.itemId);
		      	}
		    }
		},
		created(){
			this.getData();
			this.getNewsNav();
			this.getBanner();
		}

	}
</script>

<style lang="less" scoped="scoped">
.newcenter{
	.img{
		width:100%;
		height:350px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.path{
		margin-top: 20px;
		margin-bottom: 20px;
		i{
			font-size: 20px;
		}
		span{
			color: #00A0FF;
		}
		.news{
			width: 100px;
			height: 40px;
			/*border: 1px solid salmon;*/
			color: forestgreen;
			margin-left: 5px;
			margin-right: 5px;
		}
	}
		.content{
		margin-top: 50px;
		.title{
			text-align: center;
			ul{
				li{
					cursor:pointer;
					display: inline-block;
					margin-left: 40px;
					width: 120px;
					height: 40px;	
					background: #eee;	
					text-align: center;
					line-height: 40px;	
				}
				.active{
					background: #00A0FF;
					color: #fff;
				}
			}
			P{
				margin-top: 50px;
				font-size: 26px;
				color: #00A0FF;
			}
			h3{
				margin-top: 10px;
				font-size: 26px;
				font-weight: 600;
				margin-bottom: 50px;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/NewCenter/NewCenter.vue